/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConsumerTaskStatus,
    ConsumerTaskStatusFromJSON,
    ConsumerTaskStatusFromJSONTyped,
    ConsumerTaskStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface BulkTranslationTaskView
 */
export interface BulkTranslationTaskView {
    /**
     * 
     * @type {string}
     * @memberof BulkTranslationTaskView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkTranslationTaskView
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkTranslationTaskView
     */
    externalCommunicationId?: string;
    /**
     * 
     * @type {ConsumerTaskStatus}
     * @memberof BulkTranslationTaskView
     */
    status?: ConsumerTaskStatus;
    /**
     * 
     * @type {number}
     * @memberof BulkTranslationTaskView
     */
    progressPercentage?: number;
    /**
     * 
     * @type {Date}
     * @memberof BulkTranslationTaskView
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BulkTranslationTaskView
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof BulkTranslationTaskView
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkTranslationTaskView
     */
    translatedCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkTranslationTaskView
     */
    translatedItemIds?: Array<string> | null;
}

export function BulkTranslationTaskViewFromJSON(json: any): BulkTranslationTaskView {
    return BulkTranslationTaskViewFromJSONTyped(json, false);
}

export function BulkTranslationTaskViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkTranslationTaskView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'externalCommunicationId': !exists(json, 'externalCommunicationId') ? undefined : json['externalCommunicationId'],
        'status': !exists(json, 'status') ? undefined : ConsumerTaskStatusFromJSON(json['status']),
        'progressPercentage': !exists(json, 'progressPercentage') ? undefined : json['progressPercentage'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
        'translatedCount': !exists(json, 'translatedCount') ? undefined : json['translatedCount'],
        'translatedItemIds': !exists(json, 'translatedItemIds') ? undefined : json['translatedItemIds'],
    };
}

export function BulkTranslationTaskViewToJSON(value?: BulkTranslationTaskView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'externalCommunicationId': value.externalCommunicationId,
        'status': ConsumerTaskStatusToJSON(value.status),
        'progressPercentage': value.progressPercentage,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'totalItems': value.totalItems,
        'translatedCount': value.translatedCount,
        'translatedItemIds': value.translatedItemIds,
    };
}


